const ExportButton = ({ isExporting, onExport }) => {
    return (
        <>
            {isExporting ? (
                <span className="text-muted mr-2">
                    <span
                        className="spinner-border spinner-border-sm align-middle mr-1"
                        role="status"
                        aria-hidden="true"
                        style={{ color: 'rgb(76, 225, 182)' }}
                    ></span>
                    Exporting...
                </span>
            ) : (
                <span className="text-blue pointer mr-2" onClick={onExport}>
                    Export to CSV
                </span>
            )}
        </>
    );
};

export default ExportButton;
